import { JsonPatchUtilities } from "../index.mjs";

//This class is used to determine if a certain type of change has taken place on a document.
class JsonPatchFilteringUtilities {
    static doesChangeMatch(docBefore, docAfter, jsonPatchFilter) {
        const patch = JsonPatchUtilities.generatePatch(docBefore, docAfter);
        return JsonPatchFilteringUtilities.doesPatchMatch(patch, jsonPatchFilter);
    }
    static doesPatchMatch(jsonPatch, jsonPatchFilter) {
        let matches = false;
        for (const jsonPatchOperationFilter of jsonPatchFilter) {
            let operationMatch = JsonPatchFilteringUtilities.doesPatchMatchOperation(jsonPatch, jsonPatchOperationFilter);
            if (operationMatch) {
                matches = true;
                break;
            }
        }
        return matches;
    }
    static doesChangeMatchOperation(docBefore, docAfter, jsonPatchOperationFilter) {
        const patch = JsonPatchUtilities.generatePatch(docBefore, docAfter);
        return JsonPatchFilteringUtilities.doesPatchMatchOperation(patch, jsonPatchOperationFilter);
    }
    static doesPatchMatchOperation(jsonPatch, jsonPatchOperationFilter) {
        let matches = false;
        for (const patchOperation of jsonPatch) {
            let operationMatches = true;
            for (const [patchKey, patchValue] of Object.entries(jsonPatchOperationFilter)) {
                switch (patchKey) {
                    case 'from':
                        if (!patchOperation.from.startsWith(jsonPatchOperationFilter.from)) {
                            operationMatches = false
                        }
                        break;
                    case 'path':
                        if (!patchOperation.path.startsWith(jsonPatchOperationFilter.path)) {
                            operationMatches = false
                        }
                        break;
                    //Use a Function to match the value
                    case 'valueMatcher':
                        const valueMatcherResult = jsonPatchOperationFilter.valueMatcher(patchOperation.value, patchOperation, jsonPatch);
                        if (!valueMatcherResult) {
                            operationMatches = false
                        }
                        break;
                    default:
                        if (patchOperation[patchKey] !== jsonPatchOperationFilter[patchKey]) {
                            operationMatches = false
                        }
                        break;
                }
                if (!operationMatches) {
                    break;
                }
            }
            if (operationMatches) {
                matches = true;
                break;
            }
        }
        return matches;
    }
    static doesChangeMatchUsingMatcherFunction(docBefore, docAfter, changeMatcherFunction, thisContext) {
        const patch = JsonPatchUtilities.generatePatch(docBefore, docAfter);
        const matcherResult = changeMatcherFunction.call(thisContext, docBefore, docAfter, patch);
        return new Boolean(matcherResult).valueOf()
    }
    static doesPatchMatchUsingMatcherFunction(jsonPatch, patchMatcherFunction, thisContext) {
        const matcherResult = patchMatcherFunction.call(thisContext, jsonPatch);
        return new Boolean(matcherResult).valueOf();
    }
}
export { JsonPatchFilteringUtilities };
export default JsonPatchFilteringUtilities;